import React from 'react';
import DropdownBase from '../DropdownBase';
const base = function () {
  let type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'admin';
  return "".concat(process.env.REACT_APP_BASE_URL, "/").concat(type).concat(process.env.REACT_APP_URL_ENV, "/");
};
const name = 'Admin';
const items = [{
  link: "".concat(base(), "app_settings"),
  label: 'App Settings'
}, {
  link: "".concat(base(), "notifications"),
  label: 'Notifications'
}, {
  link: "".concat(base(), "modules"),
  label: 'React Modules'
}, {
  link: "".concat(base(), "roles"),
  label: 'Roles'
}, {
  link: "".concat(base(), "systems"),
  label: 'Systems'
}, {
  link: "".concat(base(), "user_maps"),
  label: 'User Maps'
}, {
  link: "".concat(base(), "users"),
  label: 'Users'
}];
const elianAdminItems = [{
  link: "".concat(base(), "roles"),
  label: 'Roles'
}, {
  link: "".concat(base(), "systems"),
  label: 'Systems'
}];
const superAdmin = props => props.userModules().includes('admin');
const Admin = props => /*#__PURE__*/React.createElement(DropdownBase, {
  name: name,
  items: superAdmin(props) ? items : elianAdminItems
});
export default Admin;